import moment, {Moment} from 'moment';
import _ from 'lodash';
import {parseSisTime} from 'util/SisDateTime';

export function cacheTTL2nextRefresh(cacheTTL?: string | null, timestamp: Moment = moment()) {
	if (!cacheTTL) return null;
	const ttlParts = _.map(cacheTTL.split(' '), c => c.trim());
	let timeouts = _.compact(_.map(ttlParts, str => {
		if (!str) return;
		if (str.indexOf('P') === 0) {
			// parse iso 8601 period
			let m = moment(timestamp).add(moment.duration(str));
			if (m.isValid() && m.isAfter(timestamp)) return m;
		} else if (str.indexOf(':') >= 0) {
			// parse time ( h:mm, h:mm:ss )
			let m = parseSisTime(str);
			if (m.isBefore(timestamp)) m.add(1, 'd');
			if (m.isValid() && m.isAfter(timestamp)) return m;
		} else if (console && typeof console.warn === 'function') {
			console.error(cacheTTL, 'contains wrong cacheTTL String format:', str);
		}
	}));
	let refreshAt = _.min(timeouts);
	return refreshAt
}